import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
  SiChakraui,
  SiRedux
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { IoLogoJavascript } from "react-icons/io";
import licious from "../../Assets/Requird-image/licious.png"
import urban from "../../Assets/Requird-image/urbancompany.png"
import himalaya from "../../Assets/Requird-image/himalaya.png"
import ssense from "../../Assets/Requird-image/ssense.png"
import homedepot from "../../Assets/Requird-image/homedepot.png"
import shopbop from "../../Assets/Requird-image/shopbop.png"
import mcd from "../../Assets/Requird-image/mcd.png"



export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different" data-aos="fade-right">
          Projects
        </h2>
        {/* <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={urban}
                  alt="Google Tic-tac-toe"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Urban Company</h2>
              <p>
              Urban Company is Asia's largest online home services platform. Launched in 2014, Urban Company today operates in India, Australia, Singapore, the USA, the UAE and The Kingdom of Saudi Arabia.
              </p>
              <div>
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
                <SiChakraui/>
                <SiRedux/>
              </div>
              <div>
                <a
                  href="https://urbancompanyclone.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/iShilajit/tense-visitor-349"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={himalaya}
                  alt="Google Tic-tac-toe"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Himalayausa</h2>
              <p>
              This is our construct week group project at Masai School. We have cloned the website himalayausa.com. We build the frontend part of website using React, React-Redux. You can check the project by clicking on the link below.
              </p>
              <div>
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
                <SiChakraui/>
                <SiRedux/>
              </div>
              <div>
                <a
                  href="https://himalayausaclone.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/AnuragPawar-132/closed-birthday-4512"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div> */}
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={ssense}
                  alt="Mc Donland Restaurant application"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>SSENSE</h2>
              <p>
              SSENSE has garnered critical acclaim as both an e-commerce engine and a producer of cultural content, generating an average of 100 million monthly page views. Approximately 80% of its audience is between the ages of 18 to 40.
              </p>
              <div>
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
                <SiTailwindcss />
              </div>
              <div>
                <a
                  href="https://ssense-clone.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/iShilajit/SSENSE-Clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={shopbop}
                  alt="shopbop.com"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Shopbop-clone</h2>
              <p>
              Shopbop is the global online retail destination for style inspiration and discovery, offering women and men a curated selection of ready-to-wear & accessories from over 1,000 established and emerging designers. Debuting new arrivals,. Built on React js, Tailwind, 
              TailBlocks for front end and localstorage on backend. It's a team project completed executed in 6 days.
              </p>
              <div>
              <FaReact />
                <SiHtml5 />
                <SiTailwindcss />
                <IoLogoJavascript />
             
              </div>
              <div>
                <a
                  href="  https://shopbop.netlify.app/
                  "
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/iShilajit/shopbopclone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={homedepot}
                  alt="homedepot-clone"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>HomeDepot-clone</h2>
              <p>
              The Home Depot, Inc., commonly known as Home Depot, 
              is the largest home improvement retailer in the United States,
               supplying tools, construction products, appliances, and services.
                The company is headquartered in incorporated Cobb County, Georgia, 
              with an Atlanta mailing address. The Home Depot, Inc.
              items at a single platform. Built on HTML, CSS, 
              JavaScript for front end and localstorage for backend.
              </p>
              <div>
                
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div>
                <a
                  href="https://visionary-pastelito-fbdbfd.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/iShilajit/HomeDepotClone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={licious}
                  alt="licious clone"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Licious-clone </h2>
              <p>
             
Licious is a Bengaluru-based meat and seafood brand. 
The company serves the best, fresh and clean fish, chicken, meat, and eggs online.
Built on HTML, CSS, JavaScript for front end and localstorage for backend.
              </p>
              <div>
              <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div>
                <a
                  href="http://licioussclone.netlify.app"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                  See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/iShilajit/Licious-Clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
       
      </div>
    </>
  );
};
